import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './TagGroup.scss';

interface TagGroupProps {
    containerClassName?: string;
    headerText: string | GenericLazyString;
    suggestedItems: object[];
    render: Function;
}

export const TagGroup = (props: TagGroupProps) => {
    return (
        <section className={`tag-group ${props?.containerClassName || ''}`}>
            <div className="eds-l-pad-left-2 eds-l-pad-bot-8">
                <h3 className="eds-text-hs eds-text-color--grey-700">
                    {props.headerText}
                </h3>
            </div>
            <section className="tag-group__tags">
                {props.suggestedItems.map((tag) => props.render(tag))}
            </section>
        </section>
    );
};
